module.exports = __webpack_public_path__ + "static/media/Paris Cam 02.png0.8eba27cf.webp";